import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '@/api/dashboard';
import { usageApi, type UsageParams } from '@/api/usage';
import { queryKeys } from '@/lib/query-keys';
import { useTenantId } from '@/providers/TenantProvider';

export function useRoleDashboard() {
  return useQuery({
    queryKey: queryKeys.dashboard.role(),
    queryFn: () => dashboardApi.getRoleDashboard(),
    refetchInterval: 15_000,
  });
}

export function useDashboardSummary() {
  const tenantId = useTenantId();
  return useQuery({
    queryKey: queryKeys.dashboard.summary(tenantId),
    queryFn: () => dashboardApi.getSummary(tenantId),
    enabled: !!tenantId,
    refetchInterval: 15_000,
  });
}

export function useDashboardActivity() {
  const tenantId = useTenantId();
  return useQuery({
    queryKey: queryKeys.dashboard.activity(tenantId),
    queryFn: () => dashboardApi.getActivity(tenantId),
    enabled: !!tenantId,
    refetchInterval: 30_000,
  });
}

export function useDashboardErrors() {
  const tenantId = useTenantId();
  return useQuery({
    queryKey: queryKeys.dashboard.errors(tenantId),
    queryFn: () => dashboardApi.getErrors(tenantId),
    enabled: !!tenantId,
    refetchInterval: 30_000,
  });
}

export function useDashboardHealthStrip() {
  const tenantId = useTenantId();
  return useQuery({
    queryKey: queryKeys.dashboard.healthStrip(tenantId),
    queryFn: () => dashboardApi.getHealthStrip(tenantId),
    enabled: !!tenantId,
    refetchInterval: 30_000,
  });
}

export function useTenantUsage(params?: UsageParams) {
  const tenantId = useTenantId();
  return useQuery({
    queryKey: ['usage', tenantId, params ?? {}],
    queryFn: () => usageApi.getTenantUsage(tenantId, params),
    enabled: !!tenantId,
    refetchInterval: 30_000,
  });
}
